














import { Component, Vue } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import pdfvuer from 'pdfvuer'; 

@Component({
    components: {
        pdfvuer,
    },
})
export default class PreviewMedia extends Vue {
    public pdfPageCount: number = 1;

    constructor() {
        super();
    }

    get getPdfPageCount() {
        try {
            const pdf = pdfvuer.createLoadingTask(this.previewMediaBase64());
            pdf.then((pdfvuerInstance: any) => {
                this.pdfPageCount = pdfvuerInstance.numPages;
            });
            return this.pdfPageCount;
        } catch (error) {
            console.log(error);
        }
    }

    public previewMedia() {
        return this.$store.getters['Documents/getPreviewMedia'];
    }

    public previewMediaBase64() {
        return `data:application/pdf;base64,${this.previewMedia().base64}`;
    }

    public cancel() {
        this.$store.commit(Mutations.SET_PREVIEW_MEDIA_VISIBILITY, false);
    }
    
    public downloadPreviewDocument() {
        saveAs(this.previewMediaBase64(), this.previewMedia().original_filename);
    }
}
